import { createGlobalStyle } from 'styled-components';

export const PerfectScrollbarGlobalStyles = createGlobalStyle`
  /* perfect-scrollbar v0.7.1 */
  .ps {
    touch-action: auto;
    overflow: hidden !important;
    -ms-overflow-style: none;
  }
  @supports (-ms-overflow-style: none) {
    .ps {
      overflow: auto !important;
    }
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .ps {
      overflow: auto !important;
    }
  }
  .ps.ps--active-x > .ps__scrollbar-x-rail, .ps.ps--active-y > .ps__scrollbar-y-rail {
    display: block;
    background-color: transparent;
  }
  .ps.ps--in-scrolling.ps--x > .ps__scrollbar-x-rail {
    background-color: #eee;
    opacity: 0.9;
  }
  .ps.ps--in-scrolling.ps--x > .ps__scrollbar-x-rail > .ps__scrollbar-x {
    background-color: #999;
    height: 11px;
  }
  .ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail {
    background-color: #eee;
    opacity: 0.9;
  }
  .ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y {
    background-color: #999;
  }
  .ps > .ps__scrollbar-x-rail {
    display: none;
    position: absolute;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    bottom: 0;
    height: 15px;
  }
  .ps > .ps__scrollbar-x-rail > .ps__scrollbar-x {
    position: absolute;
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, height 0.2s linear, width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
    bottom: 2px;
    height: 6px;
  }
  .ps > .ps__scrollbar-x-rail:hover > .ps__scrollbar-x, .ps > .ps__scrollbar-x-rail:active > .ps__scrollbar-x {
    height: 11px;
  }
  .ps > .ps__scrollbar-y-rail {
    display: none;
    position: absolute;
    opacity: 0;
    border-radius: 4px;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    right: 3px;
    width: 8px;
  }
  .ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
    position: absolute;
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, height 0.2s linear, width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
    right: 0;
    width: 8px;
  }
  .ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y, .ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y {
    width: 8px;
  }
  .ps:hover.ps--in-scrolling.ps--x > .ps__scrollbar-x-rail {
    background-color: #eee;
    opacity: 0.9;
  }
  .ps:hover.ps--in-scrolling.ps--x > .ps__scrollbar-x-rail > .ps__scrollbar-x {
    background-color: #999;
    height: 11px;
  }
  .ps:hover.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail {
    background-color: #eee;
    opacity: 0.9;
  }
  .ps:hover.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y {
    background-color: #999;
    width: 8px;
  }
  .ps:hover > .ps__scrollbar-x-rail, .ps:hover > .ps__scrollbar-y-rail {
    /* background-color: #eee;
    */
    opacity: 0.9;
  }
  .ps:hover > .ps__scrollbar-x-rail:hover {
    /* background-color: #eee;
    */
    opacity: 0.9;
  }
  .ps:hover > .ps__scrollbar-x-rail:hover > .ps__scrollbar-x {
    background-color: #999;
  }
  .ps:hover > .ps__scrollbar-y-rail:hover {
    /* background-color: #eee;
    */
    opacity: 0.9;
  }
  .ps:hover > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
    background-color: #999;
  }
`;
